import axios from 'axios'
import { notifyError } from '@/infrastructure/sentry'

export type Loading = 'idle' | 'pending' | 'succeeded' | 'failed'

export interface ApiCallBase {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: any
  loading: Loading
  error?: unknown
}

export const initialApiState: ApiCallBase = {
  response: {},
  loading: 'idle'
}

export const apiClient = axios.create({
  withCredentials: true,
  timeout: 60_000
})

// Bridge for auth0's getAccessTokenSilently, which is only reachable via hook.
// useAuth registers it; the interceptor pulls a valid token per request.
type TokenGetter = () => Promise<string>
let getTokenSilently: TokenGetter = async () => ''
export const registerTokenGetter = (fn: TokenGetter) => {
  getTokenSilently = fn
}

apiClient.interceptors.request.use(async (config) => {
  try {
    const token = await getTokenSilently()
    if (token) config.headers.Authorization = `Bearer ${token}`
  } catch (error) {
    console.error(error)
  }
  return config
})

apiClient.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    console.warn(error)
    if (!isErrorToIgnore(error)) notifyError(error)
    return Promise.reject(error)
  }
)

function isErrorToIgnore(error: unknown): boolean {
  if (axios.isCancel(error)) return true
  if (axios.isAxiosError(error)) {
    if (error.response?.status === 401) return true
    if (error.response?.status === 404) return true
    if (error.code === 'ERR_NETWORK') return true
    if (error.code === 'ECONNABORTED') return true
  }
  return false
}
